var React = require('react');

function ArrowDownBoldInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.97634853 15.8333333c-.55139403.0006796-1.07636983-.2356765-1.44076922-.6486689l-8.17546958-9.27428163c-.53741715-.63917943-.46525346-1.58962884.16253401-2.14069363.62778746-.55106479 1.58156809-.50117777 2.14819651.11236034l7.14884859 8.11000662c.03955588.0450365.09665045.0708622.15665969.0708622.06000927 0 .11710387-.0258257.15665967-.0708622l7.1488486-8.11000662c.3589374-.4269038.9214082-.62629683 1.4697592-.5210222.548351.10527464.9965521.49870051 1.1711679 1.02803799.1746157.52933749.0482509 1.11153937-.3301966 1.5213175l-8.1729696 9.27095513c-.3650234.4139921-.8907108.6514703-1.44326917.6519954z","fill":"#b3b3b3","fillRule":"evenodd","transform":"translate(0 -3)"}));
}

ArrowDownBoldInline.defaultProps = {"height":"13","viewBox":"0 0 20 13","width":"20"};

module.exports = ArrowDownBoldInline;

ArrowDownBoldInline.default = ArrowDownBoldInline;
